module.exports = __webpack_public_path__ + "static/img/homeTurn.b5d7dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeTurn.png
// module id = JW1v
// module chunks = 0